import i18n from '@/lang'

export default [
  {
    path: '/',
    name: 'home',
    // component: Home,
    component: () => import('@/pages/Home'),
    meta: {
      title: i18n.t('router.main.home'),
      requireAuth: true,
      isSupportMobile: true
    }
  },
  {
    path: '/rehab/template/:id',
    name: 'rehabTemplate',
    // component: RehabTemplate,
    component: () => import('@/pages/RehabTemplate'),
    meta: {
      title: i18n.t('router.main.rehabTemplate'),
      requireAuth: true
    }
  },
  {
    path: '/rehab/template/:id/:level',
    name: 'modifyLevelOfTemplate',
    // component: ModifyLevelOfTemplate,
    component: () => import('@/pages/ModifyLevelOfTemplate'),
    meta: {
      title: i18n.t('router.main.modifyLevelOfTemplate'),
      requireAuth: true
    }
  },
  {
    path: '/password/new/:token',
    name: 'passwordModify',
    // component: PasswordModify,
    component: () => import('@/pages/PasswordModify'),
    meta: {
      title: i18n.t('router.main.passwordModify'),
      requireAuth: true,
      isSupportMobile: true
    }
  },
  {
    path: '/password/new/finish',
    name: 'passwordModifyFinished',
    // component: PasswordModifyFinished,
    component: () => import('@/pages/PasswordModifyFinished'),
    meta: {
      title: i18n.t('router.main.passwordModifyFinished'),
      requireAuth: true,
      isSupportMobile: true
    }
  },
  {
    path: '/auth/email',
    name: 'verifyEmailRequiresAuth',
    // component: Email,
    component: () => import('@/pages/Email'),
    meta: {
      title: i18n.t('router.main.verifyEmailRequiresAuth'),
      requireAuth: true,
      isSupportMobile: true
    }
  },
  {
    path: '/verify',
    name: 'verify',
    // component: Verify,
    component: () => import('@/pages/Verify'),
    meta: {
      title: i18n.t('router.main.verify'),
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/verify/email',
    name: 'verifyEmail',
    // component: Email,
    component: () => import('@/pages/Email'),
    meta: {
      title: i18n.t('router.main.verifyEmail'),
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/register/:token',
    name: 'register',
    // component: Register,
    component: () => import('@/pages/Register'),
    meta: {
      title: i18n.t('router.main.register'),
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/login',
    name: 'login',
    // component: Login,
    component: () => import('@/pages/Login'),
    meta: {
      title: i18n.t('router.main.login'),
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/password/email',
    name: 'passwordEmail',
    // component: PasswordEmail,
    component: () => import('@/pages/PasswordEmail'),
    meta: {
      title: i18n.t('router.main.passwordEmail'),
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/password/reset/:token',
    name: 'passwordReset',
    // component: PasswordReset,
    component: () => import('@/pages/PasswordReset'),
    meta: {
      title: i18n.t('router.main.passwordReset'),
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/password/finish',
    name: 'passwordResetFinished',
    // component: PasswordResetFinished,
    component: () => import('@/pages/PasswordResetFinished'),
    meta: {
      title: i18n.t('router.main.passwordResetFinished'),
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/token/invalid',
    name: 'tokenInvalid',
    // component: TokenInvalid,
    component: () => import('@/pages/TokenInvalid'),
    meta: {
      title: i18n.t('router.main.tokenInvalid'),
      requireAuth: false,
      isSupportMobile: true
    }
  },
  {
    path: '/error',
    name: 'serverError',
    // component: ServerError,
    component: () => import('@/pages/ServerError'),
    meta: {
      title: i18n.t('router.main.serverError'),
      isSupportMobile: true
    }
  },
  {
    path: '/service/unavailable',
    name: 'serviceUnavailable',
    // component: ServiceUnavailable,
    component: () => import('@/pages/ServiceUnavailable'),
    meta: {
      title: i18n.t('router.main.serviceUnavailable'),
      isSupportMobile: true
    }
  },
  {
    path: '/404',
    name: 'notFound',
    // component: NotFound,
    component: () => import('@/pages/NotFound'),
    meta: {
      title: i18n.t('router.main.notFound'),
      isSupportMobile: true
    }
  },
  {
    path: '*',
    redirect: '/404'
  }
]



// WEBPACK FOOTER //
// ./src/router/main.js